module.exports = "<div class=\"container\">\r\n  <div class=\"boo-wrapper\">\r\n    <div class=\"boo\">\r\n      <div class=\"face\"></div>\r\n    </div>\r\n    <div class=\"shadow\"></div>\r\n\r\n    <h1>Whoops!</h1>\r\n    <p>\r\n      We couldn't find the page you\r\n      <br />\r\n      were looking for.\r\n    </p>\r\n  </div>\r\n</div>\r\n\r\n<app-footer-icons [userTypeId]=\"userTypeId\" [planId]=\"planId\" [isHome]=\"false\"></app-footer-icons>\r\n"


//////////////////
// WEBPACK FOOTER
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/page-404/page-404.component.html
// module id = ../../../../../src/app/page-404/page-404.component.html
// module chunks = 2